<div
  class="question"
  [formGroup]="form"
  [ngSwitch]="question.controlType"
  *ngIf="showQuestions"
>
  <div [formGroup]="formGroup">
    <div
      *ngSwitchCase="'boolean'"
      class="if-question"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div>
        <div
          class="bool-question-divider-container"
          *ngIf="question.key === 'isPrimaryOnInsurance'"
        >
          <mat-divider></mat-divider>
        </div>
        <p
          class="if-question-label"
          [ngClass]="{
            favorite: question.favorite,
            'unexpected-answer': question.isNotExpectedAnswer
          }"
          [innerHTML]="
            (question.label | translate) + (question.required ? '*' : '')
          "
        ></p>

        <span *ngIf="question.isNotExpectedAnswer" class="unexpected-answer"
          >(Unexpected answer)</span
        >

        <div class="if-question-hint" *ngIf="question.hint">
          <mat-hint>{{ question.hint | translate }}</mat-hint>
        </div>

        <div
          class="if-question-radios"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <mat-radio-group formControlName="value" (change)="onBoolChange()">
            <div class="if-question-bool">
              <mat-radio-button
                class="radio-button"
                [value]="true"
                color="primary"
              >
                {{ 'common.yes' | translate | questionLabel: { value: 'yes', scorer: question.scorer } }}
              </mat-radio-button>
            </div>

            <div class="if-question-bool">
              <mat-radio-button
                class="radio-button"
                [value]="false"
                color="primary"
              >
                {{ 'common.no' | translate | questionLabel: { value: 'no', scorer: question.scorer } }}
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </div>

        <mat-error
          *ngIf="
            (parent &&
              parent.errors &&
              question.required &&
              formGroup.controls['value'].value == null) ||
            (formGroup.controls['value'].invalid &&
              formGroup.controls['value'].touched)
          "
        >
          {{ 'patient-intake.custom-question.error.required' | translate }}
        </mat-error>
      </div>
      <button
        *ngIf="showAddNote"
        fxFlex="40px"
        mat-icon-button
        type="button"
        [matTooltip]="'patient-intake.add-note' | translate"
        (click)="openNoteDialog()"
      >
        <mat-icon color="primary">add</mat-icon>
      </button>
    </div>

    <div
      *ngSwitchCase="'input'"
      [class.email-container]="question.type === 'email'"
    >
      <div
        *ngIf="question.mask"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <mat-form-field appearance="fill">
          <mat-label>{{ question.label | translate }}</mat-label>
          <input
            matInput
            [id]="question.key ? question.key : question.id"
            formControlName="value"
            [type]="question.type"
            [placeholder]="question.placeholder | translate"
            [required]="question.required"
            [autocomplete]="question.autocomplete"
            [maskito]="question.mask"
            [fxFlex.xs]="100"
          />
          <mat-icon *ngIf="question.iconSuffix" matSuffix>{{
            question.iconSuffix
          }}</mat-icon>
          <mat-hint
            *ngIf="question.hint"
            [innerHTML]="question.hint | translate"
          ></mat-hint>
          <mat-error [translate]="getErrorMessage()"></mat-error>
        </mat-form-field>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>

      <div
        *ngIf="!question.mask"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <mat-form-field
          appearance="fill"
          [class.email-wrapper]="question.type === 'email'"
        >
          <mat-label>{{ question.label | translate }}</mat-label>
          <input
            matInput
            [id]="question.isCustom ? question.id : question.key"
            formControlName="value"
            [type]="question.type"
            [placeholder]="question.placeholder | translate"
            [required]="question.required"
            [autocomplete]="question.autocomplete"
            [fxFlex.xs]="100"
            mmxTrim
          />
          <mat-icon *ngIf="question.iconSuffix" matSuffix>{{
            question.iconSuffix
          }}</mat-icon>
          <mat-hint
            *ngIf="question.hint"
            [innerHTML]="question.hint | translate"
          ></mat-hint>
          <mat-error [translate]="getErrorMessage()"></mat-error>
        </mat-form-field>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
      <div class="grid-option page-wrap">
        <mat-progress-spinner
          *ngIf="isPulling"
          color="primary"
          mode="indeterminate"
          diameter="20"
          strokeWidth="1"
        ></mat-progress-spinner>
        <div *ngIf="eligibility && !isPulling">
          <strong>Coverage status: </strong>
          <ng-container *ngIf="eligibility.valid">
            <span
              matTooltipPosition="above"
              matTooltip="Patient has valid coverage"
            >
              <mat-icon class="mat-icon material-icons add" color="primary"
                >check</mat-icon
              >
              Valid
            </span>
          </ng-container>
          <ng-container *ngIf="eligibility.active">
            <span
              matTooltipPosition="above"
              matTooltip="Patient has active coverage"
            >
              <mat-icon class="mat-icon material-icons add" color="primary"
                >check</mat-icon
              >
              Active
            </span>
          </ng-container>
          <ng-container *ngIf="!eligibility.active && eligibility.valid">
            <span
              matTooltipPosition="above"
              matTooltip="Coverage inactive. Out of date 😭."
            >
              <mat-icon class="mat-icon material-icons" color="warn"
                >close</mat-icon
              >
              Inactive
            </span>
          </ng-container>
          <ng-container *ngIf="!eligibility.valid">
            <span
              matTooltipPosition="above"
              matTooltip="Eligibility response was invalid"
            >
              <mat-icon class="mat-icon material-icons" color="warn"
                >close</mat-icon
              >
              Invalid
            </span>
          </ng-container>
          <p *ngIf="eligibility.data.reject_reason">
            {{ eligibility.data.reject_reason }}
          </p>
        </div>
      </div>
      <div
        class="small-checkbox-under-hint-text"
        *ngIf="question?.options?.allowUnknownInsurance"
      >
        <mat-checkbox
          class="small-checkbox"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="allowUnknownInsurance"
          (change)="onAllowUnknownInsuranceChange()"
          color="primary"
        >
          {{
            'patient-intake.insurance-section.field-insurance-provider-number-text'
              | translate
          }}
          {{ question.label | translate }}
        </mat-checkbox>
      </div>
    </div>

    <div *ngSwitchCase="'phone'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field appearance="fill">
          <mat-label>{{ question.label | translate }}</mat-label>
          <mmx-phone-field
            [id]="question.key ? question.key : question.id"
            [name]="question.key ? question.key : question.id"
            [required]="question.required"
            [formControl]="question.control.controls['value']"
          ></mmx-phone-field>
          <mat-icon *ngIf="question.iconSuffix" matSuffix>{{
            question.iconSuffix
          }}</mat-icon>
          <mat-hint
            *ngIf="question.hint"
            [innerHTML]="question.hint | translate"
          ></mat-hint>
          <mat-error [translate]="getErrorMessage()"></mat-error>
        </mat-form-field>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
      <div *ngIf="question.subscribeSms">
        <mat-checkbox
          class="small-checkbox"
          [name]="subscribeSmsKey"
          [formControl]="question.controls[question.subscribeSmsKey]"
          color="primary"
        ></mat-checkbox>
        <a (click)="openTerms()"
          ><small [translate]="question.subscribeSmsText"></small
        ></a>
      </div>
    </div>

    <div *ngSwitchCase="'textarea'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field appearance="fill">
          <mat-label>{{ question.label | translate }}</mat-label>
          <textarea
            matInput
            matTextareaAutosize
            matAutosizeMinRows="1"
            matAutosizeMaxRows="5"
            [id]="question.isCustom ? question.id : question.key"
            formControlName="value"
            [placeholder]="question.placeholder | translate"
            [required]="question.required"
          ></textarea>
          <mat-icon *ngIf="question.iconSuffix" matSuffix>{{
            question.iconSuffix
          }}</mat-icon>
          <mat-hint *ngIf="question.hint">{{
            question.hint | translate
          }}</mat-hint>
          <mat-error [translate]="getErrorMessage()"></mat-error>
        </mat-form-field>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <div class="file-upload" *ngSwitchCase="'input-file-upload'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex="100">
          <mmx-file-upload
            [id]="question.key || question.id"
            [label]="question.label | translate"
            [insurance]="question.insurance"
            [required]="question.required"
            [control]="formGroup.controls['value']"
            [previewImageUrl]="question.value"
          >
          </mmx-file-upload>
          <mat-error
            *ngIf="
              question.control.controls['value'].invalid &&
              !question.control.pristine
            "
            [translate]="getErrorMessage()"
          ></mat-error>
        </div>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <div *ngSwitchCase="'date'">
      <div class="date-container">
        <mat-form-field appearance="fill">
          <mat-label [translate]="question.label"></mat-label>
          <mmx-date-selector-input
            placeholder="MM/DD/YYYY"
            [id]="question.isCustom ? question.id : question.key"
            [formControl]="formGroup.controls['value']"
            [required]="question.required"
            [max]="question.max"
            [min]="question.min"
          ></mmx-date-selector-input>
          <mat-hint
            *ngIf="question.hint"
            [innerHTML]="question.hint | translate"
          ></mat-hint>
          <mat-error
            *ngIf="
              question.control.controls['value'].invalid &&
              !question.control.pristine
            "
            [innerHTML]="getErrorMessage() | translate: { value: 'today' }"
          ></mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="address" *ngSwitchCase="'address'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mmx-address-field
          fxFlex
          formGroupName="value"
          [form]="formGroup.controls['value']"
          [required]="question.required"
          [countyFieldEnabled]="countyFieldEnabled"
        ></mmx-address-field>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <ng-container *ngSwitchCase="'autocomplete'">
      <mat-form-field appearance="fill">
        <input
          matInput
          type="text"
          formControlName="value"
          [placeholder]="question.label | translate"
          [required]="question.required"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option.value"
          >
            {{ option.viewValue }}
          </mat-option>
        </mat-autocomplete>

        <mat-icon *ngIf="question.iconSuffix" matSuffix>{{
          question.iconSuffix
        }}</mat-icon>
        <mat-hint *ngIf="question.hint">{{
          question.hint | translate
        }}</mat-hint>
        <mat-error [translate]="getErrorMessage()"></mat-error>
      </mat-form-field>
      <button
        *ngIf="showAddNote"
        fxFlex="40px"
        mat-icon-button
        type="button"
        [matTooltip]="'patient-intake.add-note' | translate"
        (click)="openNoteDialog()"
      >
        <mat-icon color="primary">add</mat-icon>
      </button>
    </ng-container>

    <div *ngSwitchCase="'table'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mmx-table [form]="formGroup" [question]="question"></mmx-table>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <div class="dropdown-container" *ngSwitchCase="'dropdown'">
      <p
        class="title-question"
        *ngIf="(question.label | translate).length >= 40"
      >
        {{ question.label | translate }}
      </p>
      <div fxFlex fxLayoutGap="20px">
        <mat-form-field fxFlex appearance="fill">
          <mat-label *ngIf="(question.label | translate).length < 40">{{
            question.label | translate
          }}</mat-label>
          <mat-select
            [id]="question.isCustom ? question.id : question.key"
            formControlName="value"
            [placeholder]="question.placeholder | translate"
            [required]="question.required"
            [multiple]="question.multiple"
            (selectionChange)="onSelectChange($event.value)"
            [compareWith]="dropdownCompareFn"
          >
            <mat-option [value]="" *ngIf="!question.multiple">{{
              'common.none' | translate
            }}</mat-option>
            <mat-option
              *ngFor="let option of question.options | async"
              [value]="option.value"
            >
              {{ option.viewValue | translate | questionLabel: { value: option.value, scorer: question.scorer } }}
            </mat-option>
          </mat-select>
          <mat-icon *ngIf="question.iconSuffix" matSuffix>{{
            question.iconSuffix
          }}</mat-icon>
          <mat-hint *ngIf="question.hint">{{
            question.hint | translate
          }}</mat-hint>
          <mat-error [translate]="getErrorMessage()"></mat-error>
        </mat-form-field>

        <div *ngIf="otherFieldVisible$ | async" fxFlex>
          <mat-form-field appearance="fill">
            <mat-label>
              {{ question.otherFieldSettings?.fieldLabel || ('patientIntake.custom-question.other.label' | translate) }}
            </mat-label>
            <input
              #otherFieldInput
              matInput
              [formControl]="otherFieldControl"
            >
          </mat-form-field>
        </div>

        <button
          *ngIf="showAddNote"
          fxFlex="nogrow"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <div *ngSwitchCase="'slider'" fxLayout="column">
      <div class="body-question-label">
        {{ question.label | translate }} <span *ngIf="question.required">*</span>
      </div>
      <mat-slider class="slider"
        [max]="question.options['slider'].max"
        [min]="question.options['slider'].min"
        [step]="1"
        [discrete]="true"
        [showTickMarks]="true">
        <input matSliderThumb [id]="question.key ? question.key : question.id"
               [name]="question.key ? question.key : question.id"
               [required]="question.required" formControlName="value">
        <div class="tick-text left">{{ question.options['slider'].minLabel }}</div>
        <div class="tick-text right">{{ question.options['slider'].maxLabel }}</div>
      </mat-slider>
      <mat-hint *ngIf="question.hint" [innerHTML]="question.hint | translate"></mat-hint>
      <mat-error *ngIf="formGroup.controls['value'].invalid && formGroup.controls['value'].touched" [translate]="getErrorMessage()"></mat-error>
    </div>

    <div *ngSwitchCase="'bodySelector'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <div class="body-question-label">
            {{ question.label | translate }}
            <span *ngIf="question.required">*</span>
          </div>
          <mmx-body-question
            [question]="question"
            [form]="form"
          ></mmx-body-question>
          <mat-error *ngIf="formGroup.controls['value'].touched">{{
            getErrorMessage() | translate
          }}</mat-error>
        </div>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <div
      *ngSwitchCase="'canvas'"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div>
        <p
          class="if-question-label"
          [innerHTML]="question.label | translate"
        ></p>
        <mmx-canvas
          [height]="300"
          [width]="300"
          [existingImageSrc]="question?.value"
          [imageSrc]="question?.options?.imageURL"
          (data)="onDraw($event)"
        ></mmx-canvas>
      </div>
      <button
        *ngIf="showAddNote"
        fxFlex="40px"
        mat-icon-button
        type="button"
        [matTooltip]="'patient-intake.add-note' | translate"
        (click)="openNoteDialog()"
      >
        <mat-icon color="primary">add</mat-icon>
      </button>
    </div>

    <div *ngSwitchCase="'radio-button'" class="radio-question">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <div class="radio-question-label">
            {{ question.label | translate
            }}<ng-container *ngIf="question.required">*</ng-container>
          </div>
          <mat-hint class="radio-hint" *ngIf="question.hint">{{
            question.hint | translate
          }}</mat-hint>
          <mat-radio-group
            class="radio-container"
            fxLayout="column"
            formControlName="value"
            [required]="question.required"
            (change)="onRadioChange()"
          >
            <mat-radio-button
              class="radio-button"
              *ngFor="let opt of question.options"
              [value]="opt.value"
              color="primary"
            >
              {{ opt.viewValue | translate | questionLabel: { value: opt.value, scorer: question.scorer } }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-error
            *ngIf="
              formGroup.controls['value'].invalid &&
              formGroup.controls['value'].touched
            "
            [translate]="getErrorMessage()"
          ></mat-error>
        </div>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <div *ngSwitchCase="'checkbox'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <div class="checkbox-question-label">
            {{ question.label | translate
            }}<ng-container *ngIf="question.required">*</ng-container>
          </div>
          <mat-hint *ngIf="question.hint" class="checkbox-hint">{{
            question.hint | translate
          }}</mat-hint>
          <mat-selection-list
            class="checkbox-container"
            formControlName="value"
            fxLayout="column"
          >
            <mat-list-option
              color="primary"
              checkboxPosition
              [disableRipple]="true"
              [value]="opt"
              *ngFor="let opt of question.options"
            >
              {{ opt | translate | questionLabel: { value: opt, scorer: question.scorer } }}
            </mat-list-option>
          </mat-selection-list>
          <mat-error
            *ngIf="
              formGroup.controls['value'].invalid &&
              formGroup.controls['value'].touched
            "
            [translate]="getErrorMessage()"
          ></mat-error>
        </div>
        <button
          *ngIf="showAddNote"
          fxFlex="40px"
          mat-icon-button
          type="button"
          [matTooltip]="'patient-intake.add-note' | translate"
          (click)="openNoteDialog()"
        >
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </div>

    <ng-container *ngSwitchCase="'label'">
      <div class="ql-editor p-0" [innerHTML]="question.label | translate"></div>
    </ng-container>

    <ng-container *ngSwitchCase="'score-result'">
      <ng-container *ngIf="question.value">
        <div>
          {{ question.label | translate }}
        </div>
        <div>
          <strong>{{ question.value }}</strong>
        </div>
      </ng-container>
    </ng-container>

    <small *ngIf="question.isCustom && question.clinicianId && clinicianName">
      (Edited by {{ clinicianName }})
    </small>

    <div
      *ngIf="
        question.isCustom &&
        showAddNote &&
        (formGroup.controls['note'].value || showNote)
      "
    >
      <mat-form-field appearance="fill" class="note">
        <mat-label>{{ 'common.note' | translate }}</mat-label>
        <textarea
          matInput
          matTextareaAutosize
          matAutosizeMinRows="1"
          matAutosizeMaxRows="5"
          formControlName="note"
        ></textarea>
        <mat-icon *ngIf="question.iconSuffix" matSuffix>{{
          question.iconSuffix
        }}</mat-icon>
      </mat-form-field>
      <mat-divider></mat-divider>
    </div>
  </div>
</div>

<mmx-if-questions
  [question]="question"
  [form]="form"
  *ngIf="question.ifQuestions && showIfQuestions"
></mmx-if-questions>
